import css from 'styled-jsx/css';
import { colorPalette, display, sansSerif } from 'styles/css-constants';
import { sharedPalette, warmGrays } from 'styles/colors/constants';

export default css.global`
  .Post {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    max-width: 800px;
    padding: 0 1rem;
  }

  .Post h2 {
    margin: 0.75rem 0 1rem;
    font-family: ${display};
    font-size: var(--fontScale3);
  }

  .Post h3 {
    margin: 0 0 1rem;
  }

  .Post__saveToRecipeBoxActions,
  .Post .AmpPageActions--post-top,
  .Post__cake-tag,
  .Post__byline,
  .Post__headline,
  .Post__kickerTags,
  .Post__image.Post__item--first {
    order: -2;
  }

  .Post .AmpPageActions--post-top,
  .Post__cake-tag,
  .Post__kicker,
  .Post__tags,
  .AmpPageActions,
  .Post__headline {
    text-align: center;
    justify-content: center;
  }

  .Post .AmpPageActions {
    margin-bottom: 1rem;
  }

  .Post__ad {
    margin: 1rem auto 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ddd;
  }

  .Post__ad::before {
    content: 'Advertisement';
    display: block;
    margin-bottom: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: #ddd;
    text-align: center;
    font-family: ${sansSerif};
    font-size: 12px;
    border-bottom: 1px solid #ddd;
  }

  .Post__ad amp-ad {
    display: block;
  }

  .Post__affiliate-slot {
    margin-bottom: 1rem;
    order: -1;
  }

  .Post__author,
  .Post__published {
    display: block;
    font-family: ${sansSerif};
    font-size: 12px;
    letter-spacing: 0.05em;
    font-style: italic;
  }

  .Post__author {
    margin-right: 0.375rem;
    border-right: 1px solid ${colorPalette.gray};
    padding-right: 0.375rem;
    font-style: normal;
  }

  .Post__authorIndicator {
    font-style: italic;
    text-transform: lowercase;
    margin-left: 0.25rem;
  }

  .Post__author-link {
    color: ${warmGrays[7]};
    text-decoration: none;
  }

  .Post__byline {
    margin-bottom: 1rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .Post__cake {
    margin-bottom: 1rem;
  }

  .Post__emailSignup {
    margin-bottom: 1.5rem;
  }

  .Post__gallery:nth-child(5),
  .Post__image:nth-child(5) {
    order: -2;
  }

  .Post__gallery {
    margin-bottom: 1.5rem;
  }

  .Post__headline {
    margin: 0 0 1rem;
    padding: 0;
    font-family: ${display};
    font-size: 30px;
    line-height: 1.3;
  }

  .Post__image {
    padding-bottom: 1.5rem;
  }

  .Post__faq {
    margin-bottom: 1.5rem;
  }

  .Post__inPostVideoAd {
    margin: 0.5rem 0 1.5rem;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    padding: 1.5rem;
  }

  .Post__inPostVideoAd::before {
    content: 'watch related';
    margin-bottom: 0.25rem;
    display: block;
    color: #999;
    font-family: ${sansSerif};
    font-size: 12px;
    letter-spacing: 0.05em;
    text-align: center;
    text-transform: uppercase;
  }

  .Post__inPostVideoAd .AmpVideo__callout {
    display: none;
  }

  .Post__kicker .Post__kicker-link {
    display: block;
    text-decoration: none;
  }

  .Post__kicker .Post__kicker-link,
  .Post__cake {
    color: ${sharedPalette.darkWatermelon};
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg2);
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .Post__kicker .Post__kicker-link {
    display: block;
    padding: 0.25rem 0.375rem 0.25rem 0;
    font-weight: bold;
    line-height: 1.1;
  }

  .Post__kickerTags {
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Post__tag-link {
    font-size: 14px;
  }

  .Post__product {
    margin-bottom: 1.5rem;
  }

  .Post__published {
    color: ${warmGrays[7]};
  }

  .Post__thirdParty amp-iframe,
  .Post__thirdParty amp-facebook,
  .Post__thirdParty amp-twitter,
  .Post__thirdParty amp-vimeo,
  .Post__thirdParty amp-youtube,
  .Post__thirdParty .AmpReddit {
    margin: 0 auto 1.5rem;
  }

  .Post__thirdParty .AmpReddit {
    display: block;
  }

  .Post__video {
    margin-bottom: 1.5rem;
    padding: 0.5rem;
    background-color: ${sharedPalette.lightBeige};
  }

  .Post__video .AmpVideo__callout {
    margin-bottom: 0.5rem;
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
    letter-spacing: 0.02em;
    text-align: center;
    text-transform: uppercase;
  }

  .Post__video .AmpVideo__callout a {
    color: ${sharedPalette.watermelon};
    text-decoration: none;
  }

  .AmpPostLayout__cover .CoverMedia {
    margin: 1rem 0;
  }

  .AmpPostLayout__cover .CoverMedia .ImageCaption {
    padding: 0 1rem;
  }

  .PostBundle--with-cover .Post .AmpPageActions:nth-child(5) {
    order: -2;
  }

  .PostBundle--with-cover .Post .AmpPageActions ~ .AmpPageActions {
    order: inherit;
  }

  .PostBundle--with-cover .Post .AmpPageActions {
    order: -2;
  }

  .PostBylineBottom {
    text-decoration: none;
  }

  .wp-block-pullquote {
    margin: 0;
  }

  .wp-block-pullquote blockquote {
    margin: 1.5rem 0 2.5rem;
    margin-inline-start: inherit;
    display: block;
    border-top: 1px solid ${sharedPalette.watermelon};
    border-bottom: 1px solid ${sharedPalette.watermelon};
    padding: 2rem 6%;
    text-align: center;
    color: inherit;
    font-style: inherit;
  }

  .wp-block-pullquote blockquote cite {
    margin-top: 0.5rem;
    display: block;
    color: $gray--darker;
    font-family: ${sansSerif};
    font-size: 14px;
    font-style: normal;
    text-align: center;
  }

  .wp-block-pullquote blockquote cite:before {
    content: '- ';
  }

  .wp-block-pullquote blockquote p {
    margin: 0;
    padding: 0;
    color: #000;
    font-family: ${sansSerif};
    font-size: 20px;
    font-weight: 100;
    line-height: 1.25;
  }
`;
